import { Page } from '@/components';
import { Flex, Heading, Text } from '@blockanalitica/ui';
import AllocatedTable from './AllocatedTable';
import AssetsTable from './AssetsTable';
import KPI from './KPI';
import PSM3Table from './PSM3Table';
import PolTable from './PolTable';

export default function AssetsPage() {
  return (
    <Page>
      <Heading size="0">Assets in Spark Liquidity Layer</Heading>
      <KPI />
      <Heading size="2">Allocated Assets</Heading>
      <AllocatedTable showEmpty="1" />

      <Flex flexDirection="row" gap="2xs" alignItems="baseline">
        <Heading size="2">Assets</Heading>
        <Text color="muted" fontSize="-1">
          (Assets in ALM proxy)
        </Text>
      </Flex>
      <AssetsTable showEmpty="0" />

      <Flex flexDirection="row" gap="2xs" alignItems="baseline">
        <Heading size="2">PSM3</Heading>
        <Text color="muted" fontSize="-1">
          (Only USDC is counted for Allocated Assets)
        </Text>
      </Flex>
      <PSM3Table />
      <Flex flexDirection="row" gap="2xs" alignItems="baseline">
        <Heading size="2">Idle Assets</Heading>
        <Text color="muted" fontSize="-1">
          (This assets are not counted for Allocated Assets)
        </Text>
      </Flex>
      <PolTable />
    </Page>
  );
}
